module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Observação","observation-text":"Observações adicionais da solicitação"},"en-US":{"title":"Observation","observation-text":"Additional request notes"}}')
  delete Component.options._Ctor
}
